// @flow
import React from 'react';
import styled from 'styled-components';
import PageHeader from '../components/homepage/PageHeader';
import ToolsGrid from '../components/homepage/ToolsGrid';
import { tools } from '../components/homepage/utils/toolsData';
import { INK_TOOLING_GUIDES_URL } from '../components/homepage/utils/constants';
import usePageTitle, { DEFAULT_PAGE_TITLE } from '../utils/use-page-title';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 200px);
  background-color: ${({ theme }) => theme.colors.white};
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 16px 0;
`;

const HomePage: React.FC = () => {
  usePageTitle(DEFAULT_PAGE_TITLE);

  return (
    <PageWrapper>
      <ContentArea>
        <PageHeader
          title="All Tools"
          description="See all guides on"
          linkText="how to use Ink Apps"
          linkTo={INK_TOOLING_GUIDES_URL}
        />
        <ToolsGrid tools={tools} />
      </ContentArea>
    </PageWrapper>
  );
};

export default React.memo(HomePage);
